export const Projects = [


    {
        image: "/assets/images/portfolio/1_Portfolio/Portfolio.png",
        title: "projectTitle2",
        tags: ["HTML", "CSS", "JS", "React"],
        paragraph:"projectParagraph2",
        codeLink: "",
        projectLink: "https://www.gregorydemeur.be",
        projectLinkText: ""
    },
    {
        image: "/assets/images/portfolio/2_Animalice/Animalice.png",
        title: "projectTitle3",
        tags: ["HTML", "CSS", "JS", "React"],
        paragraph:"projectParagraph3",
        codeLink: "",
        projectLink: "https://www.animalice.be",
        projectLinkText: "accederAuSiteWeb"
    },
    {
        image: "/assets/images/portfolio/5_uBento/uBento.PNG",
        title: "projectTitle4",
        tags: ["Full Stack","React", "Node.js", "Firebase", "Tailwind CSS", "API Discord" ],
        paragraph: "projectParagraph4",
        codeLink: "",
        projectLink: "https://ubento-tfe.web.app/",
        projectLinkText: "voirLeProjet",
        
      },
      {
        image: "/assets/images/portfolio/6_gdm-to-do-list/gdm-to-do-list.png",
        title: "projectTitle5",
        tags: ["Full stack", "React", "Typescript", "Java","Spring", "Azure","SQL"],
        paragraph: "projectParagraph5",
        codeLink: "",
        projectLink: "https://www.gregorydemeur.be/gdm-to-do-list",
        projectLinkText: "voirLeProjet"
    },
    {
        image: "/assets/images/portfolio/10_JGConsulting/JGConsulting.png",
        title: "projectTitle9",
        tags: ["Vue 3", "Vite", "Tailwind CSS", "i18n"],
        paragraph: "projectParagraph9",
        codeLink: "",
        projectLink: "https://www.jgcm.be",
        projectLinkText: "accederAuSiteWeb"
    },
    {
        image: "/assets/images/portfolio/7_Coussinets/Coussinets.png",
        title: "projectTitle6",
        tags: ["Full Stack", "Vue 3", "Node.js", "MongoDB", "Docker", "CI/CD", "Playwright", "AI Assistant"],
        paragraph: "projectParagraph6",
        codeLink: "",
        projectLink: "https://www.lescoussinetsducoeur.be",
        projectLinkText: "accederAuSiteWeb"
    },
    {
        image: "/assets/images/portfolio/11_MobileApp/MobileApp.png",
        title: "projectTitle10",
        tags: ["React Native", "Expo", "TypeScript"],
        paragraph: "projectParagraph10",
        codeLink: "",
        projectLink: "",
        projectLinkText: ""
    },
    {
        image: "/assets/images/portfolio/8_AnnaMylee/AnnaMylee.png",
        title: "projectTitle7",
        tags: ["Nuxt 3", "TypeScript", "Tailwind CSS", "API Bandsintown", "Docker"],
        paragraph: "projectParagraph7",
        codeLink: "",
        projectLink: "https://www.annamylee.com",
        projectLinkText: "accederAuSiteWeb"
    },
    {
        image: "/assets/images/portfolio/9_DrumCoaching/DrumCoaching.png",
        title: "projectTitle8",
        tags: ["Nuxt 3", "TypeScript", "PostgreSQL", "Stripe", "Tailwind CSS", "Docker"],
        paragraph: "projectParagraph8",
        codeLink: "",
        projectLink: "https://www.drumcoaching.pro",
        projectLinkText: "accederAuSiteWeb"
    }



   
   
]